import ACTION_TYPE from "./type.action";

export const showWebView = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPE.SHOW_WEB_VIEW,
        payload: {webView: true}
  });
};
export const hideWebView = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPE.HIDE_WEB_VIEW,
        payload: {webView: false}
  });
};
export const showSideBar = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPE.SHOW_SIDE_BAR,
        payload: {sideBar: true}
  });
};
export const hideSideBar = () => async (dispatch) => {
    dispatch({
        type: ACTION_TYPE.HIDE_SIDE_BAR,
        payload: {sideBar: false}
  });
};